import { Component, OnInit, OnDestroy } from '@angular/core';
import { SearchService } from '../search.service';
import { Subscription } from 'rxjs';
import { AlternativeSearchesAvailable } from '../models/alternativesearchesavailable.model';
import { DataService } from '../../shared/data.service';

@Component({
  selector: 'app-alternative-searches',
  templateUrl: './alternative-searches.component.html',
  styleUrls: ['./alternative-searches.component.css']
})
export class AlternativeSearchesComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  alternativeSearchesAvailable: AlternativeSearchesAvailable = new AlternativeSearchesAvailable(0,0,0,0,0,0,0,0,0,0,0,0,0,0,0);
  constructor(private dataService: DataService, private searchService: SearchService) { }

  onAlternateSearchClick(field: string) {
    this.dataService.doAlternateSearch(field);
  }

  ngOnInit() {
    this.subscription = this.searchService.alternativeSearchesAvailableChanged.subscribe(
      (alternativeSearchesAvailable: AlternativeSearchesAvailable) => {
        this.alternativeSearchesAvailable = alternativeSearchesAvailable;
      }
    );
  }
  ngOnDestroy(){
    this.subscription.unsubscribe();
  }
}
